export default "__VITE_ASSET__ad41519e__"